import { api } from "@/comn";
import { TFormSchema, TGridSchema } from "@/comn/hooks";
import { comnUtils } from "@/comn/utils";
import { ptlEnvs } from "../../../comn";

/*
 *  Country Code Management Service
 * !== 국가 코드 관리 기능 서비스 ==!
 */

export const BASE = {
    path: `${ptlEnvs.base}/comnmdle/cntycd`,
    api: `${process.env.REACT_APP_API_PTL_COMN}/api/v1/osci/ptl/cd/cnty-cd`,
    nodes: [{ label: "Portal" }, { label: "Common Module" }, { label: "Code Management" }],
};

export const URLS = {
    osci0109009q: `${BASE.path}/osci0109009q`, // Country Code Management List !== 국가 코드 관리 목록 ==!
    osci0109010s: `${BASE.path}/osci0109010s`, // Country Code Registration !== 국가 코드 등록 ==!
    osci0109011s: `${BASE.path}/osci0109011s`, // Country Code Modification !== 국가 코드 수정 ==!
};

export const APIS = {
    // Retrieve a list of country codes. !== 국가코드 목록을 조회한다.==!
    getCntyCdList: (data: any, page: number, size: number) => {
        return api.get(`${BASE.api}?page=${page}&size=${size}`, {
            params: comnUtils.toGetParams(data),
        });
    },

    // Retrieve country code information. !== 국가코드 정보를 조회한다.==!
    getCntyCdInfo: (cntyCd: any) => api.get(`${BASE.api}/${cntyCd}`),

    // Save country code information !== 국가코드 정보 저장 ==!
    insertCntyCdInfo: (data: any) => {
        // TODO insertCntyCdInfo cntyCd key 유무 체킹 필요
        return api.post(`${BASE.api}`, {
            ...data,
        });
    },

    // Modify country code information !== 국가코드 정보 수정 ==!
    updateCntyCdInfo: (data: any) => {
        return api.put(`${BASE.api}`, {
            ...data,
        });
    },

    deleteCntyCdInfo: (cntyCd: any) => api.delete(`${BASE.api}/${cntyCd}`),
};

// Country Code Management Search Form !== 국가 코드 관리 검색 폼 ==!
export const SF_CNTY_CD_SRCH: TFormSchema = {
    id: "form_cntyCdSrch",
    schema: {
        cntyCd: { type: "code", label: "L_CNTY_CD", area: "cntyCd" },
        cntyNm: { type: "text", label: "L_CNTY_NM" },
    },
};

// Country Code Management List Grid Schema !== 국가 코드 관리 목록 그리드 스키마 ==!
export const SG_CNTY_CD_LIST: TGridSchema = {
    id: "grid_cntyCdList",
    options: { pagination: "out", index: true, checkbox: true },
    head: [
        { cells: [{ header: "L_CNTY_CD", binding: "cntyCd", width: "15%" }] },
        { cells: [{ header: "L_DGT3_CNTY_CD", binding: "dgt3CntyCd", width: "15%" }] },
        { cells: [{ header: "L_CNTY_NM", binding: "cntyNm", width: "*" }] },
    ],
    body: [
        { cells: [{ binding: "cntyCd", edit: false }] },
        { cells: [{ binding: "dgt3CntyCd", edit: false }] },
        { cells: [{ binding: "cntyNm", edit: false, align: "left" }] },
    ],
};

// Country Code Management Form !== 국가 코드 관리 폼 ==!
export const SF_CNTY_CD_INFO: TFormSchema = {
    id: "form_cntyCdInfo",
    schema: {
        cntyCd: {
            type: "text",
            label: "L_CNTY_CD",
            required: true,
            maxLength: 2,
            letterCase: "upper",
        },
        dgt3CntyCd: {
            type: "text",
            label: "L_DGT3_CNTY_CD",
            required: true,
            maxLength: 3,
            letterCase: "upper",
        },
        dgt3NumCntyCd: {
            type: "text",
            label: "L_DGT3_NUM_CNTY_CD",
            required: true,
            maxLength: 3,
        },
        cntyEngAbrtNm: { type: "text", label: "L_CNTY_ENG_ABRT_NM", maxLength: 100 },
        cntyNmKo: { type: "text", label: "L_CNTY_NM_KO", maxLength: 100 },
        cntyNmEn: { type: "text", label: "L_CNTY_NM_EN", maxLength: 100 },
        cntyNmTz: { type: "text", label: "L_CNTY_NM_TZ", maxLength: 100 },
    },
};
